import { AnalyticsActionType } from '../analytics/types';

const snakeToCamel = (str: string) => str?.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());

/**
 * Create custom event name based on pageName, elementType and actionName
 * @param pageName this should be where are we tracking the event,
 * @param elementType this should be the type of element to trigger this event,
 * for example: tab, button, dropdown, menu, link, etc
 * @param elementId this should be a unique name that will identify where the event was trigger,
 * for example: periodicity, periods, etc
 * @returns based on pageName = "borrower_financials", elementType = "dropdown", actionName = "periodicity"
 * Will return borrower_financials_dropdown_periodicity
 */
export const createEventName = (pageName: string, elementType: AnalyticsActionType, elementId: string) => {
  if (!elementId) {
    throw new Error('tracking :: elementId can not be undefined or empty');
  }

  // eslint-disable-next-line @oaknorth/ui/no-template-literals -- creating a key (not visible to user)
  return `${snakeToCamel(pageName)}_${snakeToCamel(elementType)}_${snakeToCamel(elementId)}`;
};
